module.exports = __webpack_public_path__ + "static/media/product-4-full.4e0b10b1.jpg";